import { AsyncStorageController } from "@ciaopeople/cp-shatsu/Storage";
import { ThrottleAsyncStorageStoreImpl } from "./ThrottleAsyncStorageStoreImpl.js";
import { ThrottleStore } from "./ThrottleStore.js";

export class ThrottleStoreAsyncStorageFactory {

    constructor(private readonly storage: AsyncStorageController<string>) {

    }

    getThrottleStore(propName: string): ThrottleStore {
        return new ThrottleAsyncStorageStoreImpl(propName, this.storage);
    }
}